import * as React from 'react';
import { Link, useTranslation } from 'gatsby-plugin-react-i18next';
import Wrapper from '@components/Wrapper';
import ResourceCard from '@components/ResourceCard';
import * as styles from './style.module.scss';

const {
  latestResources,
  latestResources__posts,
  latestResources__wrapper,
  latestResources__wrapperouter,
  latestResources__header,
  latestResources__link,
} = styles;

const LatestResources = ({ resources }) => {
  const { t } = useTranslation();

  return (
    <section className={latestResources}>
      <Wrapper classes={latestResources__wrapperouter}>
        <div className={latestResources__wrapper}>
          <div className={latestResources__header}>
            <h4>{t('latest_resources')}</h4>
            <Link to="/resources/all/" className={latestResources__link}>
              {t('playbooks_more')}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M5.36648 0.866499L9.5 5.00002L5.36648 9.13355L4.48864 8.26423L7.1179 5.63497L0.730113 5.63497L0.730113 4.36508L7.1179 4.36508L4.48864 1.74008L5.36648 0.866499Z"
                  fill="#B1BCCF"
                />
              </svg>
            </Link>
          </div>
          <div className={latestResources__posts}>
            {resources.map((resource) => (
              <ResourceCard
                key={resource.id}
                resource={resource}
                classModifier="posts"
              />
            ))}
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default LatestResources;
